import { ProductDetailModel } from "./product-detail.model";


export function getAllChildrenProducts(product: ProductDetailModel, appendSelf: boolean = false): ProductDetailModel[] {
  const products = appendSelf ? [product] : [];
  if (product.steps) {
    for (const step of product.steps) {
      if (step.products) {
        for (const childProduct of step.products) {
          products.push(...getAllChildrenProducts(childProduct, true));
        }
      }
    }
  }

  return products;
}
